export const crunchberry = {
  xlight: '#FDECF4',
  light: '#E5A5C5',
  base: '#E30C79',
  medium: '#F50B7C',
  dark: '#CC0D71',
};

export const grape = {
  xlight: '#FAF5FF',
  base: '#A381C5',
  medium: '#8D65B5',
  dark: '#59377B',
};

export const teal = {
  dark: '#006273',
  medium: '#008196',
  base: '#0095AF',
  light: '#52CEE6',
  xlight: '#EEFAFC',
};

export const gray = {
  '100': '#F7F7F7',
  '200': '#E3E5E6',
  '300': '#C6CACF',
  '400': '#8C95A1',
  '500': '#6A7685',
  '600': '#222A33',
};

export const mint = {
  base: '#28D0B2',
  dark: '#187D6A',
  light: '#E9FAF7',
};

export const peach = {
  base: '#FFA400',
  dark: '#9C6400',
  light: '#FFF6E5',
};

export const cherry = {
  base: '#CE2424',
  dark: '#901919',
  light: '#FAE9E9',
};

export const blueberry = {
  base: '#0072B0',
  light: '#F2F8FB',
};

export const eggplant = {
  base: '#682E9A',
  light: '#F7F5FA',
};

export const broccoli = {
  base: '#107A70',
  light: '#E7F2F1',
};

export const egg = '#FFFFFF';
export const karl = '#EDF4F9';
export const black = '#000000';

export const palette = {
  crunchberry,
  grape,
  gray,
  teal,
  mint,
  peach,
  cherry,
  blueberry,
  eggplant,
  broccoli,
  egg,
  white: egg,
  black: black,
};

const colors = {
  crunchberry: crunchberry.base,
  'crunchberry-dark': crunchberry.dark,
  'crunchberry-medium': crunchberry.medium,
  'crunchberry-light': crunchberry.light,
  'crunchberry-xlight': crunchberry.xlight,

  teal: teal.base,
  'teal-dark': teal.dark,
  'teal-medium': teal.medium,
  'teal-light': teal.light,
  'teal-xlight': teal.xlight,

  grape: grape.base,
  'grape-dark': grape.dark,
  'grape-medium': grape.medium,
  'grape-xlight': grape.xlight,

  'gray-100': gray['100'],
  'gray-200': gray['200'],
  'gray-300': gray['300'],
  'gray-400': gray['400'],
  'gray-500': gray['500'],
  'gray-600': gray['600'],

  mint: mint.base,
  'mint-dark': mint.dark,
  'mint-light': mint.light,

  peach: peach.base,
  'peach-dark': peach.dark,
  'peach-light': peach.light,

  cherry: cherry.base,
  'cherry-dark': cherry.dark,
  'cherry-light': cherry.light,

  blueberry: blueberry.base,
  'blueberry-light': blueberry.light,

  eggplant: eggplant.base,
  'eggplant-light': eggplant.light,

  broccoli: broccoli.base,
  'broccoli-light': broccoli.light,

  egg: egg,
  white: egg,
  black: black,
  karl: karl,
} as const;

export type ColorKeys = keyof typeof colors;

export default colors;
